import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { classNames } from '../../lib/helpers';

export default function SimplePagination({ maxPages=0, page=0, setPage }) {
  // Create const [page, setPage] = useState(0) on parent component 

  const changePage = (action) => {
    let newPage = page
    if (action === 'next') {
      newPage = page>=(maxPages-1) ? page : page + 1      
    } else if (action === 'prev') {
      newPage = page>0 ? page - 1 : 0
    }
    setPage(newPage)
  }  
  
  return(
    <>
      {maxPages > 1 && (
        <nav className="px-4 sm:px-6 mt-6 flex items-center justify-center" aria-label="Pagination">
          <div className="flex-1 flex justify-center ">
            <button 
              className={classNames(page==0 ? 'bg-gray-100 border-gray-100 cursor-not-allowed' : 'bg-white hover:bg-gray-50 border-gray-300', 'mx-1 px-4 py-3 border  text-sm text-gray-700 font-medium rounded-md')}
              // relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50
              onClick={() => {changePage('prev')}}
              disabled={page===0}
            >
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <button 
              className={classNames(page==(maxPages-1) ? 'bg-gray-100 border-gray-100 cursor-not-allowed' : 'bg-white hover:bg-gray-50 border-gray-300', 'mx-1 px-4 py-3 border  text-sm text-gray-700 font-medium rounded-md')}                  
              onClick={() => {changePage('next')}}
              disabled={page===(maxPages-1)}
            >
              <span className="sr-only">Next</span>
              <ChevronRightIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        </nav>            
      )}
    </>
  )
}